import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Organization, UserOrganization } from '../../../core/auth/models/user';
import { AuthService } from '../../../core/auth/services/auth.service';
import { Store } from '@ngxs/store';
import { AuthState } from '../../../core/auth/store/auth.state';
import { AdminService } from '../../../admin/admin.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-client-selector',
  standalone: false,
  templateUrl: './client-selector.component.html',
  styleUrl: './client-selector.component.scss'
})
export class ClientSelectorComponent implements OnInit{
  @Input() selectedClientId: string | null = null;
  @Input() label: string = 'COMMON.CLIENT';
  @Input() placeholder: string = 'COMMON.SELECT_CLIENT_PLACEHOLDER';
  @Input() headerText: string = 'COMMON.SELECT_CLIENT_PLACEHOLDER';
  @Input() autoSelectFirst: boolean = false;
  @Input() isSuperadmin: boolean = false;

  @Output() clientChanged = new EventEmitter<Organization | null>();
  userClients: UserOrganization[] = [];
  clients: Organization[] = [];
  hasClients: boolean = false;

  constructor(private authService: AuthService, private store: Store, private adminService: AdminService){}
  ngOnInit(): void {
    this.loadUserClients();
    if(!this.selectedClientId){
      this.selectedClientId = this.store.selectSnapshot(AuthState.getSelectedClient).id;
    }
    this.authService.organizationChanged.subscribe((changed: boolean)=>{
      this.selectedClientId = this.store.selectSnapshot(AuthState.getSelectedClient).id;
    });
  }

  handleChange(event: CustomEvent): void {
    const selectedId = event.detail.value;
    if(!selectedId){
      // No client selected
      this.selectedClientId = null;
      this.clientChanged.emit(null);
      return;
    }

    const selectedClient = this.clients.find(c => c.id === selectedId);

    if (selectedClient){
      this.selectClient(selectedClient);
    }
  }

  private async loadUserClients(): Promise<void> {
    if(this.isSuperadmin){
      this.clients = await lastValueFrom(this.adminService.getClients());
    } else {
      this.userClients = this.authService.getUserClients();
      this.userClients.map(uc=>this.clients.push(uc.organization));
    }
    this.hasClients = this.clients.length > 0;

    if (this.hasClients) {
      this.validateSelectedClient();
      if(!this.selectedClientId && this.autoSelectFirst){
        this.selectClient(this.clients[0]);
      }
    }
  }

  private validateSelectedClient(): void {
    if (this.selectedClientId && !this.clients.find(c => c.id === this.selectedClientId)){
      this.selectedClientId = null;
    }
  }

  private selectClient(client: Organization){
    this.selectedClientId = client.id;
    this.clientChanged.emit(client);
  }
}
